Ext.define('SA.view.ImportStepIndicator', {
    alias: 'widget.import-step-indicator',
    extend: 'Ext.Component',

    cls: 'sa-import-step-indicator',

    html: [
        '<div class="sa-import-step-indicator-step">',
            '<svg>',
                '<use href="#sa-icon-step-1"></use>',
            '</svg>',
            '<div class="sa-import-step-indicator-step-text">',
                'Select a File',
            '</div>',
        '</div>',
        '<div class="sa-import-step-indicator-step">',
            '<svg>',
                '<use href="#sa-icon-step-2"></use>',
            '</svg>',
            '<div class="sa-import-step-indicator-step-text">',
                'Identify Data Columns',
            '</div>',
        '</div>',
        '<div class="sa-import-step-indicator-step">',
            '<svg>',
                '<use href="#sa-icon-step-3"></use>',
            '</svg>',
            '<div class="sa-import-step-indicator-step-text">',
                'Review & Import',
            '</div>',
        '</div>'
    ],

    onBoxReady() {
        this.callParent(arguments);

        this.setActiveStepIndex(0);
    },

    setActiveStepIndex(activeStepIndex) {
        var steps = this.el.query('.sa-import-step-indicator-step');

        steps.forEach((el, stepIndex) => {
            var isStepDone = stepIndex < activeStepIndex,
                isStepActive = stepIndex === activeStepIndex,
                stepNumber = stepIndex + 1,
                svgUseElHref = isStepDone ? '#sa-icon-step-done' : `#sa-icon-step-${stepNumber}`;

            Ext.fly(el).ifCls(isStepDone, 'sa-import-step-indicator-step-done');
            Ext.fly(el).ifCls(isStepActive, 'sa-import-step-indicator-step-active');

            el.querySelector('use').setAttribute('href', svgUseElHref);
        });
    }
});